if (!Promise.withResolvers) {
  Promise.withResolvers = function <T>(): {
    promise: Promise<T>;
    resolve: (value: T | PromiseLike<T>) => void;
    reject: (reason?: unknown) => void;
  } {
    let resolve: (value: T | PromiseLike<T>) => void;
    let reject: (reason?: unknown) => void;

    const promise = new Promise<T>((res, rej) => {
      resolve = res;
      reject = rej;
    });

    return { promise, resolve: resolve!, reject: reject! };
  };
}

if (typeof WeakRef === "undefined") {
  (globalThis as unknown as { WeakRef: unknown }).WeakRef = class WeakRef<
    T extends object
  > {
    private _ref: T;

    constructor(target: T) {
      this._ref = target;
    }

    deref(): T | undefined {
      return this._ref;
    }
  };
}
